"use client";

import { Link, useRouter } from "@/i18n/routing";
import { Button, Spacer } from "@heroui/react";
import { useTranslations } from "next-intl";
import Image from "next/image";

export default function NotFound() {
  const t = useTranslations();
  const router = useRouter();
  return (
    <div className="min-h-[calc(100svh-var(--main-navbar-height)-var(--misc-dl-height))] flex h-full w-full flex-col items-center justify-center px-4 text-center [&>*]:z-10 mx-auto">
      <Image src="/maha_logo1.webp" width={300} height={300} alt="" />
      <Spacer y={10} />
      <h2 className="text-2xl font-thin text-primary">{t("not-found-title")}</h2>
      <Spacer y={4} />
      <p className="text-tiny">{t("not-found-description")}</p>
      <Spacer y={10} />
      <Button onPress={() => router.back()} className="gradient-secondary w-full max-w-48 text-white drop-shadow-md">
        {t("not-found-href")}
      </Button>
    </div>
  );
}
